import { CallEffect, PutEffect, SelectEffect, call, put, select } from 'redux-saga/effects';
import serviceLocator, { INDIVIDUAL_PORTAL_SVC } from '../../APIs/common/service-locator';

import {
    fetchCommunicationPreferencesFailure,
    fetchCommunicationPreferencesSuccess,
    setCommunicationPreferences,
    startFetchingPreferences
} from '../../actions/individualPortal/preferences/communicationPreferencesActionCreators';

import { selectIfCommunicationPreferencesLoaded } from '../../reducers/appReducer';

// Types

import { CommunicationPreferences } from '../../components/ssap/SsapTypes';

export function* executeSagaCallbacks(callbacks: { togglePageReadiness: (status: boolean) => void; toggleExtraDataStatus: (status: boolean) => void }) {
    if (callbacks) {
        const { togglePageReadiness, toggleExtraDataStatus } = callbacks;
        yield call(toggleExtraDataStatus, true);
        yield call(togglePageReadiness, true);
    }
}

export function* communicationPreferencesSaga({ callbacks, shouldForceUpdate }):  Generator<
    CallEffect<unknown> | PutEffect<{type: string}> | SelectEffect,
    void,
    any
> {
    try {
        // Check if communication preferences are already loaded
        const isLoaded: boolean = yield select(selectIfCommunicationPreferencesLoaded);

        if (isLoaded && !shouldForceUpdate) {
            // If already loaded and update is not forced, just return
            if (callbacks) {
                yield call(executeSagaCallbacks, callbacks);
            }
            return;
        }

        yield put(startFetchingPreferences());

        const individualPortalService: ReturnType<(...args: any) => any> = yield call(
            serviceLocator,
            INDIVIDUAL_PORTAL_SVC
        );

        const communicationPreferences: { payload: CommunicationPreferences } = yield call([
            individualPortalService,
            individualPortalService.getCommunicationPreferences
        ]);

        if(communicationPreferences) {
            yield put(fetchCommunicationPreferencesSuccess());
            yield put(setCommunicationPreferences(communicationPreferences.payload));
            if (callbacks) {
                yield call(executeSagaCallbacks, callbacks);
            }
        } else {
            yield put(fetchCommunicationPreferencesFailure());
        }
    } catch(e) {
        yield put(fetchCommunicationPreferencesFailure());
    }
}